<template>
  <div class="home">
    <home-left class="page-left" />
    <home-middle class="page-middle" />
    <home-right class="page-right" />
  </div>
</template>

<script>
import HomeLeft from '@/views/Home/components/HomeLeft'
import HomeMiddle from '@/views/Home/components/HomeMiddle'
import HomeRight from '@/views/Home/components/HomeRight'
export default {
  name: 'Home',
  components: { HomeRight, HomeMiddle, HomeLeft },
  data() {
    return {
      pageShow: true
    }
  }
}
</script>

<style lang="less" scoped>
  .home{
    width: 100%;
    height: 1285px;
    color: #ffffff;
    padding: 0 30px 40px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
  }
  .page-left, .page-middle, .page-right{
    height: 100%;
  }
  .page-left, .page-right{
    width: 455px;
  }
  .page-middle{
    flex: 1;
    margin: 0 11px;
  }
</style>
<style lang="less">
  body{
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
</style>
